import { gql } from '@apollo/client';
import { DEVICE_FRAGMENT } from '@/entities/device/@x/study';
import DIAGNOSIS_FRAGMENT from '../fragments/diagnosisFragment';
import PATIENT_FRAGMENT from '../fragments/patientFragment';

const CLINIC_STUDIES_COMPLETED_QUERY = gql`
  query clinicStudiesCompleted($filter: ClinicStudyFilterInput, $limit: Int) {
    clinicStudies(filter: $filter, limit: $limit) {
      id
      friendlyId
      externalSource {
        provider
        externalId
      }
      deviceType
      # isExternalDevice
      info {
        patient {
          ...PatientFragment
        }
        interprettingPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        referringPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        diagnosis {
          ...DiagnosisFragment
        }
        followOnStudy {
          studyType
          reportDueDate
        }
      }
      start
      stop
      studyType
      status
      reportDueDate
      timezone
      initialDurationOfStudy
      studyTimeOffset
      ecgUploadProgress
      rma
      lastStudyHistory {
        time
        status
      }
      hasArtifactReport
      linkedStudies {
        id
      }
      facility {
        id
        name
        contact {
          country
        }
        timezone
      }
      device {
        ...DeviceFragment
      }
      initDuration
      biofluxDirect {
        status
        id
      }
      isTest
      ecgDetail
      initiatedTime
    }
  }

  ${DEVICE_FRAGMENT}
  ${PATIENT_FRAGMENT}
  ${DIAGNOSIS_FRAGMENT}
`;

export default CLINIC_STUDIES_COMPLETED_QUERY;
